import { render } from "./modal.vue?vue&type=template&id=6d9df24f&scoped=true"
import script from "./modal.ts?vue&type=script&lang=js"
export * from "./modal.ts?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=6d9df24f&lang=scss&scoped=true"

import exportComponent from "I:\\Dev\\Projects\\LabManagement\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9df24f"]])

export default __exports__